import '../../styles/speaker.css';
import logo from '../../assets/images/Q3logotext.png';
import rosa from "../../assets/images/speakers/rosa.avif";
function Rosa() {
    return (
       <>
    <div class="header">
      <div class="header-content">
        <div class="left">
          <div class="header-box">
            <h1 className="title">Q<sup>3</sup> Initiative: QEthics @ USC</h1>
          </div>
          <p>September 12, 2025 - September 13, 2025</p>
          <p>University of Southern California</p>
          <p>TBD</p>
        </div>
        <div className="right">
          <img src={logo} className="logo" alt="Q^3 Logo" />
        </div>
      </div>
    </div>
    <div className="speaker-box">
      <div className="speaker-photo">
         <img src={rosa} alt="Florenta Teodoridis" className="speakerspic"/>
      </div>
      <div className="speaker-content">
      <h1>Rosa Di Felice</h1>
      <h2>Quantum Faculty at USC</h2>
    </div>  
    </div>
    <div className="speaker-content">
      <p className="p">
        Dr. Rosa Di Felice works in theoretical and computational physics of matter, with emphasis on
        ab-initio studies of biological molecules and molecules interacting with surfaces. She is the
        technical Director of the USC IBM Quantum Innovation Center and has been a visiting lecturer at
        numerous universities.
      </p>
    </div>
    </>
    );
  }
  
  export default Rosa